import React from "react";
import "./ButtonWithdrawAllEarning4.css";

function ButtonWithdrawAllEarning4(props) {
  const { className } = props;

  return (
    <div className={`button-withdraw-all-earning-20 ${className || ""}`}>
      <div className="shop-now-6 avenir-medium-black-4px">SHOP NOW</div>
    </div>
  );
}

export default ButtonWithdrawAllEarning4;
